import { onAuthStateChanged, signOut } from "firebase/auth";
import { ref, watch, computed, reactive } from "vue";
import auth from "./firebaseAuth";
import api from "@/composables/api";
import { useAnalytics } from "@/stores";

export default () => {
  const user = ref("");
  const settings = reactive({});
  const initialSettings = reactive({});
  const activeTab = ref("");
  const activeRoute = ref("login");
  const showSaveButton = ref(false);
  const isDataLoaded = ref(false);
  const isUserLoaded = ref(false);
  // From the `admin` custom claim on the Firebase token. UI-only: the
  // backend enforces admin access on its own.
  const isAdmin = ref(false);
  const currentPage = ref(1);
  const openDropdown = ref(""); // Stores which dropdown is currently open
  const selectedMenuItem = ref(""); // Stores the currently selected menu item

  const getUser = async () => {
    if (!isUserLoaded.value) {
      // await new Promise((resolve) => watch(isUserLoaded, resolve, { immediate: true }));
      await new Promise((resolve) => watch(isUserLoaded, resolve));
    }

    return auth.currentUser;
  };

  const getSettings = () => {
    isDataLoaded.value = false;
    api(`v1/user/settings`)
      .then((response) => {
        setSettings(response.data);
        // delay for testing
        // setTimeout(() => {
        //   isDataLoaded.value = true;
        // }, 5000);
        isDataLoaded.value = true;
      })
      .catch((error) => {
        if (
          error.status === 401 ||
          error.status === 403 ||
          error.status === 404
        ) {
          console.log("signing out: ", error);
          signOutUser();
        } else {
          console.log("error: ", error);
        }
      });
  };

  const saveSettings = () => {
    api(`v1/user/settings/`, {
      method: "PUT",
      body: {
        settings: settings,
      },
    })
      .then((res) => {
        // console.log("res", res.data);
        showSaveButton.value = false;
        const stringified = JSON.parse(JSON.stringify(userStore.settings));
        Object.assign(initialSettings.value, stringified);
      })
      .catch((err) => {
        // console.log("err", err);
      });
  };

  onAuthStateChanged(auth, (userobj) => {
    if (userobj) {
      // user.value = getUser();
      user.value = userobj.auth.currentUser;
      userobj
        .getIdTokenResult()
        .then((result) => {
          isAdmin.value = result.claims.admin === true;
        })
        .catch(() => {
          isAdmin.value = false;
        });
      //delay by 3 seconds
      // setTimeout(() => {
      //   isDataLoaded.value = true;
      //   getSettings();
      // }, 3000);
    } else {
      // signed out
      // console.log("observer no user");
      user.value = "";
      isAdmin.value = false;
    }
    isUserLoaded.value = true;
  });

  const signOutUser = async () => {
    try {
      const analyticsStore = useAnalytics();
      if (analyticsStore.eventBuffer?.length > 0) {
        await analyticsStore.sendEvents();
      }
    } catch (error) {
      console.error("Failed to send analytics events during logout:", error);
    }

    // Then proceed with logout regardless of analytics success
    await signOut(auth);
    user.value = "";
    activeTab.value = "login";
    activeRoute.value = "login";
  };

  const setSettings = (settingsObj) => {
    Object.assign(settings, { ...settingsObj });
    Object.assign(initialSettings, { ...settingsObj });
  };

  watch(
    settings,
    () => {
      if (JSON.stringify(settings) !== JSON.stringify(initialSettings)) {
        showSaveButton.value = true;
      }
    },
    { deep: true }
  );

  return {
    user,
    settings,
    initialSettings,
    activeTab,
    activeRoute,
    showSaveButton,
    isDataLoaded,
    isUserLoaded,
    getUser,
    getSettings,
    saveSettings,
    setSettings,
    signOutUser,
    isAdmin,
    currentPage,
    openDropdown,
    selectedMenuItem,
  };
};
